import axios from "../../service/index";
import React, { Component } from "react"
import {Form, Input, Select, Divider, message, Table, Switch,Modal, Button} from 'antd'
import "./index.less";
import UploadQiniu from '../../commponents/uploadQiniu/index'
const FormItem = Form.Item;
const {Option} = Select;

class freePunch extends Component{
  constructor(props) {
		super(props)
    this.state = {
      searchData: {
        total: 0,
				pageNum: 1,
				pageSize: 10
      },
			name: '',
			publish: '',
      freeListData: [],
      modelTitel: '新建',
      subjectIcon: '',
			swiperId: '',
      visible: false,
			fileUrl: '',
      previewisible: false,
			addName: '',
      userName: '',
      previewUrl: '',
      columns: [{
					title: '海报',
					dataIndex: 'fileUrl',
					key: 'fileUrl',
					align: 'center',
					render: (record)=> 
						<img src={record} onClick={() => {this.setState({previewisible: true,previewUrl: record})}} style={{width: '141px',height: '80px'}} alt=""/>
				},{
          title: '海报名称',
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },{
          title: '创建人',
          dataIndex: 'createName',
          key: 'createName',
          align: 'center',
        },
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},{
          title: '发布状态',
          dataIndex: 'publish',
          key: 'publish',
          align: 'center',
          render: (text,record)=> {
						return (
						<div>
							<Switch defaultChecked={text === 1 ? true : false} key={text === 1 ? true : false} onChange={(checked) => {
								let id = record.id
										let arr = this.state.freeListData
										for(let i = 0; i<arr.length; i++){
											if(id === arr[i].id){
												arr[i].publish = checked===true ? 1 : 0
												this.setState({
													freeListData: arr
												})
											}
										}
										return (
											Modal.confirm({
												title: `${checked === true ? '发布活动' : '取消发布'}`,
												okText: "确定",
												cancelText: "取消",
												content: (
													<div>
														<p>{checked === true ? '发布后此活动将同步至用户端，请谨慎操作！确定要发布吗？' : '取消发布后用户端将不展示此活动，请谨慎操作！确定要取消发布吗？'}</p>
													</div>
												),
												onOk: () => {
													this.isRelease(id, checked, 'ok')
												},
												onCancel: () => {
													this.isRelease(id, checked, 'cancel')
												}
											})
										)
							}} />
						</div>
						)
					}
        },
        {
					title: '操作',
					// key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.setState({
								swiperId: record.id,
								visible: true,
								modelTitel: '编辑',
								addName: record.name,
								subjectIcon: {
									uid: null,
									type: null,
									url: record.fileUrl,
									name: record.name
								},

							})
						}}>编辑</span>
						{record.publish === 0?<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除操作',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delSwiper(record.id)
								},
							});
						}}>删除</span>:''}
					</div>
				}]
    }
  }
  componentDidMount() {
		this.getSwiperList()
	}
  getSwiperList() {
		axios.post('/courseclockpostertemplate/list', {
			name: this.state.name,
			publish: this.state.publish,
			...this.state.searchData
		}).then(res => {
			if(res.data.code === '200'){
				this.setState({
					freeListData: res.data.data.list,
					searchData: {
						total: res.data.data.total,
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize
					}
				})
			}
		})
	}
  isRelease = (id, checked, type) => {
		let url = checked?`courseclockpostertemplate/publish/${id}`: `courseclockpostertemplate/cancelPublish/${id}`
		axios.get(url).then(res => {
			if(res.data.code === '200') {
				message.success('操作成功')
				this.getSwiperList()
			}else{
				message.error(res.data.msg)
				this.getSwiperList()
			}
		})
  }
  showModal() {
    this.setState({
      visible: true,
			modelTitel: '新建'
    })
  }
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	delSwiper = (id) => {
		axios.get(`courseclockpostertemplate/delete/${id}`).then(res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.getSwiperList()
			}else{
				message.error(res.data.msg)
			}
		})
	}
	handleOk = (e) => {
		let _this = this
		this.props.form.validateFields((err, values) => {
			console.log(values.qslcode, _this.state.addName)
			if(!err) {
				let params = {
					id: _this.state.swiperId||'',
					name: values.addName,
					fileUrl: (values.qslcode.url&&_this.state.modelTitel === '编辑')?values.qslcode.url : _this.state.qiuniuUrl+'/'+ values.qslcode.response.key
				}
				let url = _this.state.modelTitel === '新建'?'courseclockpostertemplate/add': 'courseclockpostertemplate/update'
				axios.post(url, params).then(res => {
					if(res.data.code === '200'){
						_this.props.form.resetFields();
						message.success(res.data.msg)
						_this.setState({visible: false})
						_this.getSwiperList()
					}else{
						message.error(res.data.msg)
					}
				})
			}
		})
	}
  render() {
    const {searchData, freeListData, columns, modelTitel, visible, name, publish, addName, subjectIcon, previewisible, previewUrl} = this.state
    const {getFieldDecorator} = this.props.form
    const pagination ={
			showSizeChanger: true,
			total: searchData.total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${searchData.total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getSwiperList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getSwiperList(searchData)
			},
		}
    return (
        <div className="free-punch">
          <span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>免费课打卡海报</span>
				  <Divider />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center'}}>
              <span>海报名称：</span><Input allowClear value={name} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
                placeholder="请输入海报名称"
                onChange={(e)=>{
                  e.persist()
                  this.setState({
                    name: e.target.value
                  })
                }}
                ></Input>
                <span>发布状态：</span>
                <Select value={publish} style={{width: "200px", marginRight: '20px'}} onChange={(val) => {
                      this.setState({
                        publish: val
                      })
                    }} placeholder="请选择" className="zip-width">
                      <Option value=''>全部</Option>
                      <Option value={1}>已发布</Option>
                      <Option value={0}>未发布</Option>
                  </Select>
                <Button className='my-button-primary' type='primary' onClick={() => {
                  this.getSwiperList()
                }}>搜索</Button>
                <span style={{marginLeft: '20px'}} className='my-button-txt' onClick={() => {
                  this.setState({
                    name: '',
                    publish: ''
                  },()=>{
                    this.getSwiperList()
                  })
                }}>重置</span>
              </div>
              <Button className='my-button-primary' type='primary' onClick={() => { this.showModal() }}>新增海报</Button>
          </div>
            <Table
              dataSource={freeListData}
              columns={columns}
              pagination={pagination}
              rowKey={record => record.id+''}
              rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
            />

          {visible?<Modal
            width={800}
            title={modelTitel+'免费课打卡海报'}
            okText="确认"
            cancelText="取消"
            visible={visible}
            maskClosable={false}
            destroyOnClose
            onOk={() => { this.handleOk() }}
            onCancel={() => {this.setState({ visible: false })}}
          >
            <Form labelCol={{ span: 3 }} wrapperCol={{ span: 21 }} onSubmit={this.handleOk}>
              <FormItem label={"海报名称"}>
                {getFieldDecorator('addName', {
                  initialValue: modelTitel === '编辑' ? addName : '',
                  rules: [{ required: true, message: '请输入海报名称!' }, { max: 20, message: '最多输入20个字符' }],
                })(
                  <Input allowClear placeholder='请输入海报名称' maxLength={20} />
                )}
                </FormItem>
                <Form.Item label="海报模板" key={6}>
							{getFieldDecorator('qslcode', {
								initialValue: modelTitel==='编辑'? subjectIcon: '',
								rules: [{ required: true, message: '请上传海报!' }],
							})(
								// <div>
									<UploadQiniu getQiniuUrl={this.getQiniuUrl}/>
									// <p style={{color: '#999999',fontSize: '12px',lineHeight: 1.5,marginTop: '5px'}}>仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*144px</p>
								// </div>	
							)}
						</Form.Item>
            </Form>
          </Modal>:''}
          {previewisible?<Modal
						title="预览海报"
            width={500}
            getContainer={false}
            footer={null}
            visible={previewisible}
            maskClosable={false}
            destroyOnClose
            onCancel={() => { this.setState({ previewisible: false, previewUrl: ''}) }}
          >
            <div className="preview-css">
              <img src={previewUrl} style={{width: '100%', height: 'auto'}} alt="" />
            </div>
          </Modal>:''}
        </div>
    )
  }
}
export default Form.create()(freePunch)